import { gql } from '@apollo/client';

export function modifyCommissionSplit() {
  return gql`
    mutation ModifyCommissionSplit(
      $id: String!
      $input: ModifyCommissionSplitInput!
    ) {
      production {
        modifyCommissionSplit(id: $id, input: $input)
      }
    }
  `;
}
